module.exports = __webpack_public_path__ + "img/brand-logo-white.7279d890.svg";